import type { BatchResponseResult } from './parseBatchResponse'

/**
 * Текст итога загрузки ответа поставщика — одна точка правды (№314).
 *
 * До 13.09.2026 текст собирался двумя копиями кода: в очереди квот
 * (queueActions) и в карточке заявки (useUploadResponse). Копии разъехались —
 * очередь молчала про позиции «без цены (не найдено)», хотя карточка их
 * показывала, и закупщик из очереди не понимал, почему квот меньше, чем строк
 * в файле.
 */
export function buildUploadSummary(result: BatchResponseResult): string {
  const parts = [`Загружено ${result.created} квот`]
  if (result.notFound > 0) parts.push(`${result.notFound} без цены (не найдено)`)
  if (result.skippedDuplicates > 0) parts.push(`пропущено ${result.skippedDuplicates} дублей`)
  if (result.skippedOrphans > 0) parts.push(`пропущено ${result.skippedOrphans} (нет в БД)`)
  if (result.skippedNoMatch > 0)
    parts.push(`пропущено ${result.skippedNoMatch} (нет в текущем списке)`)
  if (result.unmatched > 0)
    parts.push(`${result.unmatched} позиций удалены из заявок и не сопоставлены`)
  // Битые цены: номера строк Excel + значение ячейки — чтобы закупщик нашёл
  // ошибку в файле, а не искал её глазами по 200 строкам.
  if (result.invalidRows.length > 0) {
    const preview = result.invalidRows
      .slice(0, 5)
      .map((r) => `№${r.row}: «${r.value}»`)
      .join(', ')
    const tail = result.invalidRows.length > 5 ? ` и ещё ${result.invalidRows.length - 5}` : ''
    parts.push(`пропущено ${result.invalidRows.length} строк с битой ценой (${preview}${tail})`)
  }
  return parts.join(', ')
}
